<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    size="md"
    scrollable
  >
    <div>
      <b-form @submit.prevent="handleSubmit">
        <b-form-group label="Motivo" label-for="motivoInput">
          <b-form-input
            id="motivoInput"
            v-model="form.name"
            required
            placeholder="Ingrese el motivo"
          />
        </b-form-group>

        <b-button type="submit" variant="outline-primary" size="sm">
          {{ form.id ? "ACTUALIZAR" : "REGISTRAR" }}
        </b-button>

        <b-button
          v-if="form.id"
          variant="outline-secondary"
          size="sm"
          class="ml-2"
          @click="resetForm"
        >
          CANCELAR EDICIÓN
        </b-button>
      </b-form>

      <hr />

      <b-table
        :items="items"
        :fields="fields"
        small
        responsive
        bordered
        class="mt-2"
      >
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="outline-info"
            @click="editItem(row.item)"
            class="mr-1"
          >
            EDITAR
          </b-button>
          <!-- <b-button
            size="sm"
            variant="outline-danger"
            @click="deleteItem(row.item.id)"
          >
            ELIMINAR
          </b-button> -->
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MotivoAdelantoSueldoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/motivos.adelanto.sueldo.service.js";

export default {
  components: {
    ToastificationContent,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      showModal: true,
      items: [],
      form: {
        id: null,
        name: "",
      },
      fields: [
        { key: "id", label: "#" },
        { key: "name", label: "Motivo" },
        { key: "actions", label: "Acciones" },
      ],
    };
  },
  computed: {
    title() {
      return `MOTIVOS DE ADELANTO DE SUELDO`;
    },
  },
  mounted() {
    this.index();
  },
  methods: {
    async index() {
      try {
        this.addPreloader();
        const { data } = await MotivoAdelantoSueldoService.index();
        this.items = data;
      } catch (error) {
        this.errorNotify("Error al cargar motivos.");
      } finally {
        this.removePreloader();
      }
    },

    async handleSubmit() {
      try {
        this.addPreloader();

        if (this.form.id) {
          // UPDATE
          await MotivoAdelantoSueldoService.update(this.form);
          this.successNotify("Motivo actualizado correctamente.");
        } else {
          // CREATE
          await MotivoAdelantoSueldoService.store(this.form);
          this.successNotify("Motivo registrado correctamente.");
        }

        this.resetForm();
        this.index();
      } catch (error) {
        this.errorNotify("Ocurrió un error al guardar.");
      } finally {
        this.removePreloader();
      }
    },

    editItem(item) {
      this.form = { ...item };
    },

    // async deleteItem(id) {
    //   if (!confirm("¿Está seguro de eliminar este motivo?")) return;

    //   try {
    //     this.addPreloader();
    //     await MotivoAdelantoSueldoService.delete({ id });
    //     this.successNotify("Motivo eliminado.");
    //     this.index();
    //   } catch (error) {
    //     this.errorNotify("Error al eliminar.");
    //   } finally {
    //     this.removePreloader();
    //   }
    // },

    resetForm() {
      this.form = { id: null, name: "" };
    },

    successNotify(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Éxito",
          icon: "CheckIcon",
          variant: "success",
          text: message,
        },
      });
    },

    errorNotify(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "AlertCircleIcon",
          variant: "danger",
          text: message,
        },
      });
    },
  },
};
</script>

<style scoped>
</style>
